import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  getUserSession,
  getUserRoles
} from '../../../redux/actions/config/session'

import { APP_HOME } from '../../routes'
import { LAYOUT_AUTH_LOGIN } from '../navigation'

/**
 * Chequeamos que el usuario tenga un token
 *  - Si no tiene lo enviamos al login
 *  - Si tiene lo enviamos a la acción por defecto
 */
class AuthLoading extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount () {
    if (this.props.user) {
      this.props.history.push(APP_HOME)
    } else {
      this.props.history.push(LAYOUT_AUTH_LOGIN)
    }
  }

  render () {
    return (
      <>
        <div>AuthLoading</div>
      </>
    )
  }
}

function MapStateToProps (state) {
  return {
    roles: getUserRoles(state),
    user: getUserSession(state)
  }
}

export default connect(MapStateToProps, {})(AuthLoading)
